export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-3xl border border-background-200/70 p-8 md:p-12">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              关于五一吃瓜网
            </h2>
            <p className="text-sm text-foreground-500">www.51chigua.com</p>
          </div>

          <div className="max-w-2xl mx-auto space-y-4">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              五一吃瓜网是专注于热门事件追踪与娱乐八卦聚合的一站式资讯平台。我们致力于为全国瓜友提供最快、最全、最便捷的吃瓜资讯入口，让每一位用户都能随时随地获取最新热点内容。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              平台内容覆盖<strong>娱乐圈热点、网红动态、综艺爆料、影视花边、体育八卦、社会热议</strong>等 15 个以上频道，编辑团队 7×24 小时全天候追踪全网热点，确保重大吃瓜事件第一时间上线推送。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              五一吃瓜网坚持<strong>客观呈现、多方核实</strong>的内容原则，所有资讯免费开放浏览，无需注册登录即可畅享全部内容。我们倡导理性吃瓜、文明讨论的社区氛围，让吃瓜成为一种健康有趣的娱乐方式，持续为千万瓜友提供优质的吃瓜资讯服务。
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 mt-8 pt-8 border-t border-background-200/70">
            <div className="text-center">
              <span className="block text-2xl md:text-3xl font-heading font-bold text-primary-500">500+</span>
              <span className="text-xs md:text-sm text-foreground-600">日更资讯数</span>
            </div>
            <div className="text-center">
              <span className="block text-2xl md:text-3xl font-heading font-bold text-accent-500">15+</span>
              <span className="text-xs md:text-sm text-foreground-600">覆盖频道</span>
            </div>
            <div className="text-center">
              <span className="block text-2xl md:text-3xl font-heading font-bold text-primary-500">1000万+</span>
              <span className="text-xs md:text-sm text-foreground-600">月活瓜友</span>
            </div>
            <div className="text-center">
              <span className="block text-2xl md:text-3xl font-heading font-bold text-accent-500">7×24</span>
              <span className="text-xs md:text-sm text-foreground-600">全天候更新</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}